const initialState = {
    togglerValue: true
};
export default initialState;